import { motion } from "framer-motion";
import { DoorOpen, HeartPulse, Smile } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
  {
    icon: DoorOpen,
    step: "1",
    title: "Walk in",
    copy: "No appointment. No paperwork. Just step up to the Hub.",
    testid: "step-walkin",
  },
  {
    icon: HeartPulse,
    step: "2",
    title: "Get checked",
    copy: "In about a minute, it checks your heart, blood pressure, oxygen and more.",
    testid: "step-checked",
  },
  {
    icon: Smile,
    step: "3",
    title: "Connects you to a real doctor on video, when needed",
    copy: "Not every checkup needs a doctor. Our AI reviews your vitals first. If everything is normal, you get your report instantly with no wait. If something is flagged or you request it, we connect you in under 5 minutes to a real doctor on video.",
    testid: "step-walkout",
  },
];

export const HowItWorks = () => (
  <section className="py-28 lg:py-36 px-6 sm:px-12 max-w-6xl mx-auto" data-testid="how-it-works">
    <motion.h2
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE }}
      className="font-display font-semibold tracking-tight text-center text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15]"
    >
      Easy as 1, 2, 3.
    </motion.h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
      {STEPS.map((s, i) => (
        <motion.div
          key={s.testid}
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
          className="rounded-[2rem] bg-white border border-black/5 shadow-sm p-9 text-center"
          data-testid={s.testid}
        >
          <s.icon className="w-7 h-7 mx-auto text-[#1B2A4A]" />
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#808080] mt-6">Step {s.step}</p>
          <h3 className="font-display font-bold tracking-tight text-[#3A3A3C] text-2xl mt-2">{s.title}</h3>
          <p className="text-sm sm:text-base text-[#474747] leading-relaxed mt-3">{s.copy}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
